/**
 * Api keys in preferences, that we are matching against.
 */
const apiPrefs = {
  address1: 'mtsRequireAddress1',
  address2: 'mtsRequireAddress2',
  address3: 'mtsRequireAddress3'
};

const extra = (locale) => ({
  address1: { required: true, msg: locale['validation.required'] },
  address2: { required: true, msg: locale['validation.required'] },
  address3: { required: true, msg: locale['validation.required'] }
});

/**
 * Get permissions for specific field, based on specific criteria.
 *
 * @param {object} wirePreferences those are coming from api
 * @param {string} type field type we want to get permissions for (intermediary only for now)
 */
// eslint-disable-next-line import/prefer-default-export
export const getPermissions = ({ locale, paymentType, wirePreferences }) => {
  const extras = {};

  Object.keys(apiPrefs).forEach((field) => {
    const pref = wirePreferences[apiPrefs[field]];

    if (!pref) {
      extras[field] = {
        ...extras[field],
        optional: true
      };
      return;
    }

    const required = wirePreferences[apiPrefs[field]][paymentType];

    extras[field] = { extra: [] };

    if (required) {
      extras[field] = {
        extra: extra(locale)[field]
      };
    }

    extras[field] = {
      ...extras[field],
      optional: !required
    };
  });

  return extras;
};
